import React, { useMemo } from 'react';
import { Icon, Button } from '@iq/react-components';

import { useSelector } from 'react-redux';
import { useSubscription } from '../../../../bundles/visualizations';
import { format } from '../../../../units';
import LabelWithTooltip from '../../../LabelWithTooltip';
import { getVariableById } from '../../../../bundles/sources';

const MetricVisualization = ({ visualization, panelId, isPreview = false, disconnected }) => {
  const { id, configuration = {} } = visualization;
  const { latestValues: values, initialLoaded } = useSubscription(id, panelId);

  const [firstVar] = values || [];
  const { variable: variableId } = firstVar || {};
  const sourceVar = useSelector((state) => getVariableById(state, variableId));

  const [value, quality] = useMemo(() => {
    if (initialLoaded && values) {
      const [, lastValue, lastValueQuality] = firstVar?.value || [];
      if (lastValue || lastValue === 0) {
        const currValue = Number.isNaN(lastValue) ? null : lastValue;
        return [currValue, lastValueQuality];
      }
    }
    return [null, 0];
  }, [initialLoaded, values, firstVar]);

  let unitLabel;
  // Determine the unit label to use for formatting if the user selects a unit from the dropdown other than the default.
  // If no custom unit label is added, configuration.unitLabel is undefined.
  if (configuration.unit !== 'variable-default' && !configuration.unitLabel) {
    unitLabel = configuration.unit;
  } else {
    unitLabel = configuration.unitLabel;
  }

  const displayUnit =
    configuration.unit === 'variable-default' ? sourceVar?.unit || '' : configuration.unit;
  const { value: formattedValue, unit } = format(
    displayUnit,
    value ?? configuration.defaultEmptyValue,
    configuration.decimals,
    unitLabel
  );

  // invalidate if quality !== 1 (valid) or no data connectivity (disconnected)
  const isDataInvalid = quality > 1 || disconnected;

  return (
    <div
      className={`metric-visualization-component ${isPreview ? 'preview' : 'normal'} ${isDataInvalid ? 'invalid-data' : ''}`}
    >
      <div className="wrapper">
        <div className="label">
          <LabelWithTooltip name={configuration?.label} />
          {isDataInvalid ? (
            <Button
              tooltip="Invalid signal value"
              design="text"
            >
              <Icon
                icon="he-help"
                size="s"
                color="#FF7300"
              />
            </Button>
          ) : null}
        </div>
        <div className="value-wrapper">
          <div className="value">{formattedValue}</div>
          {(value || value === 0) && (
            <div className="unit">{configuration.unitLabel ? configuration.unitLabel : unit} </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default MetricVisualization;
